/**
 * Work Management Service
 * Work tracking and management service API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchTargetDto } from './searchTargetDto';


export interface SearchRelationshipsByTargetsRequestDto { 
    /**
     * Array of targets to search for
     */
    targets: Array<SearchTargetDto>;
    /**
     * Filter by work item statuses
     */
    statuses?: Array<string>;
    /**
     * Number of items to return
     */
    limit?: number;
    /**
     * Number of items to skip
     */
    offset?: number;
    /**
     * Fields to expand in the response
     */
    expand?: Array<SearchRelationshipsByTargetsRequestDto.ExpandEnum>;
    /**
     * Only return parent work items (where parentWorkItemId is null)
     */
    parentOnly?: boolean;
    /**
     * When true, returns ALL relationships for matching work items (not just those matching the targets)
     */
    includeAllRelationships?: boolean;
    /**
     * Filter by target audience (provider or patient)
     */
    targetAudience?: SearchRelationshipsByTargetsRequestDto.TargetAudienceEnum;
}
export namespace SearchRelationshipsByTargetsRequestDto {
    export type ExpandEnum = 'children' | 'comments' | 'history' | 'parent' | 'event-log' | 'work-type';
    export const ExpandEnum = {
        Children: 'children' as ExpandEnum,
        Comments: 'comments' as ExpandEnum,
        History: 'history' as ExpandEnum,
        Parent: 'parent' as ExpandEnum,
        EventLog: 'event-log' as ExpandEnum,
        WorkType: 'work-type' as ExpandEnum
    };
    export type TargetAudienceEnum = 'provider' | 'patient';
    export const TargetAudienceEnum = {
        Provider: 'provider' as TargetAudienceEnum,
        Patient: 'patient' as TargetAudienceEnum
    };
}


